import { configureStore } from "@reduxjs/toolkit";
import newUserReducer from "./slices/userSlice";
import authReducer from "./slices/authSlice";
import tourReducer from "./slices/tourSlice";
import customerReducer from "./slices/customerSlice";
import orderReducer from "./slices/orderSlice";
import pastDeliveriesReducer from "./slices/pastDeliveriesSlice";
import routeReducer from "./slices/routeSlice";
import handoverReducer from "./slices/handoverSlice";
import zipcodeReducer from "./slices/zipcodeSlice";
import supplierReducer from "./slices/supplierSlice";
import supplierLocationsReducer from "./slices/supplierLocationsSlice";
import supplierGroupsReducer from "./slices/supplierGroupsSlice";
import rolesReducer from "./slices/rolesSlice";
import permissionsReducer from "./slices/permissionsSlice";
import uiReducer from "./slices/uiSlice";
import customersImportReducer from "./slices/customersImportSlice";
import accountPermissionsReducer from "./slices/accountPermissionsSlice";
import orderNumbersReducer from "./slices/orderNumbersSlice";
import ordersImportReducer from "./slices/ordersImportSlice";
import atbasOrdersImportReducer from "./slices/atbasOrdersImportSlice";
import diagnosticsReducer from "./slices/diagnosticsSlice";

const store = configureStore({
  reducer: {
    newUser: newUserReducer,
    auth: authReducer,
    tours: tourReducer,
    customers: customerReducer,
    orders: orderReducer,
    pastDeliveries: pastDeliveriesReducer,
    routes: routeReducer,
    ui: uiReducer,
    handovers: handoverReducer,
    zipcodes: zipcodeReducer,
    suppliers: supplierReducer,
    supplierLocations: supplierLocationsReducer,
    supplierGroups: supplierGroupsReducer,
    roles: rolesReducer,
    permissions: permissionsReducer,
    customersImport: customersImportReducer,
    accountPermissions: accountPermissionsReducer,
    orderNumbers: orderNumbersReducer,
    ordersImport: ordersImportReducer,
    atbasOrdersImport: atbasOrdersImportReducer,
    diagnostics: diagnosticsReducer,
  },
});

export default store;
